import { Ng2StateDeclaration } from '@uirouter/angular';
import {
    paginationUrlQueryParamsValidator,
} from '@client/app/shared-modules/state/state-validators/pagination-url-query-params-validator';
import {
    AdminLabelsComponent,
} from '@client/app/feature-modules/admin/modules/admin-labels/components/admin-labels/admin-labels.component';
import {
    paginationUrlQueryParamsDeclarations,
} from '@client/app/shared-modules/state/state-params-declarations/pagination-params-declarations';
import { Injectable } from '@angular/core';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';

@Injectable({ providedIn: 'root' })
export class LabelsAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        if (this.activeFeatureService.isFeatureActive('labels')) {
            return true;
        }

        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.customer.admin.dashboard', params) as unknown as Promise<void>;
        });
    }
}
export const AdminLabelsStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin.labels',
        url: '/labels?page_size&page&search',
        params: {
            ...paginationUrlQueryParamsDeclarations(),
            search: {
                dynamic: true,
                value: '',
            },
        },
        resolve: [
            {
                token: 'labelsAccess',
                deps: [LabelsAccessGuard, Transition],
                resolveFn: (guard: LabelsAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
        data: { title: 'Acquia Web Governance - Labels' },
        redirectTo: paginationUrlQueryParamsValidator('base.customer.admin.labels'),
        component: AdminLabelsComponent,
    },
];
